import Vue from "vue";
import PublicApp from "./PublicApp.vue";
import router from "./router/public";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import VueSweetalert2 from "vue-sweetalert2";
import { installTokenBridge, rootMixin } from "./lib/createRoot";

let { version, releaseDate } = require("./../package.json");

Vue.config.productionTip = false;

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "sweetalert2/dist/sweetalert2.min.css";
import "../public/css/brand.css";
import "@/assets/css/colors.css";
import "@/assets/css/main.css";
import "@/assets/css/custom.scss";
import "@/assets/css/chrome.css";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueSweetalert2);

const bridge = installTokenBridge(router);

new Vue({
  router,
  mixins: [rootMixin(bridge)],
  render: (h) => h(PublicApp),
  data: {
    appVersion: version,
    releaseDate,
  },
}).$mount("#app");
